// extracted by mini-css-extract-plugin
export const normal = "footer-module--normal--2-byl";
export const floor = "footer-module--floor--e9onV";